import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {SnackBarActions} from '@aviary/store/snack-bar/snack-bar.actions';
import {ElevatedButtonComponent} from '@aviary/buttons/elevated-button/elevated-button.component';
import {NgClass, NgTemplateOutlet} from '@angular/common';

type SnackBarType = 'default' | 'success' | 'error';

@Component({
  selector: 'mx-component-lib-snack-bars',
  host: {
    class: 'component-lib-content'
  },
  templateUrl: './component-lib-snack-bars.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ElevatedButtonComponent, NgClass, NgTemplateOutlet]
})
export class ComponentLibSnackBarsComponent {
  private readonly store: Store = inject(Store);

  public show(type: SnackBarType, withAction: boolean): void {
    const message: string = `${this.displayNameFor(type)} snack bar`;
    const action: string | undefined = withAction ? 'ACTION' : undefined;

    switch (type) {
      case 'success':
        this.store.dispatch(SnackBarActions.showSuccess(message, action));
        break;
      case 'error':
        this.store.dispatch(SnackBarActions.showError(message, action));
        break;
      default:
        this.store.dispatch(SnackBarActions.show(message, action));
    }
  }

  public showCenteredMultiline(type: Exclude<SnackBarType, 'default'>): void {
    const lines: string[] = [`Centered multiline ${type} snack bar`, 'Second line of the message'];

    if (type === 'success') {
      this.store.dispatch(SnackBarActions.showCenteredMultilineSuccess(lines));
    } else {
      this.store.dispatch(SnackBarActions.showCenteredMultilineError(lines));
    }
  }

  private displayNameFor(type: SnackBarType): string {
    return type.charAt(0).toUpperCase() + type.slice(1);
  }
}
